angular.module('elfium').filter('reportPhaseOrder', ['REPORT_PHASE', function (REPORT_PHASE) {
    var that = this;
    that.reportPhaseOrder = [REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA, REPORT_PHASE.PROBEHLA_PRVNI_SCHUZKA, REPORT_PHASE.CHCI_NABIDKU, 
    							REPORT_PHASE.PRVNI_PREDANI_NABIDKY, REPORT_PHASE.ROZHODNUTI_O_NABIDCE, REPORT_PHASE.ZADANI_DO_PT];
    return function (phase1, phase2) {
        var compare1 = phase1 && that.reportPhaseOrder.indexOf(phase1);
        var compare2 = phase2 && that.reportPhaseOrder.indexOf(phase2);
        if (compare1 == compare2) {
            return 0;
        }
        if (compare1 > compare2) {
            return 1;
        }
        if (compare1 < compare2) {
            return -1;
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportPhaseOrderFilter.ts